import React from 'react'
import { 
  Package, 
  ShoppingCart, 
  TrendingUp, 
  Truck, 
  Clock, 
  CheckCircle,
  AlertCircle,
  MoreHorizontal,
  Search,
  Bell,
  User,
  Menu,
  X,
  Calendar,
  Filter
} from 'lucide-react';
// const Shippmenttable = ({shipments}) => {
//   return (
//     <div className="bg-white p-4 rounded-md shadow overflow-x-auto ">
//       <h3 className="text-lg font-semibold mb-4">Latest Vanilla Bean Shipments</h3>
//       <table className="min-w-full text-sm text-left">
//         <thead>
//           <tr className="border-b text-gray-600">
//             <th className="py-2 px-4">Shipment ID</th>
//             <th className="py-2 px-4">Client</th>
//             <th className="py-2 px-4">Quantity (kg)</th>
//             <th className="py-2 px-4">Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {shipments.map((row) => (
//             <tr key={row.id} className="border-b last:border-none">
//               <td className="py-2 px-4 font-medium text-gray-800">{row.id}</td>
//               <td className="py-2 px-4">{row.client}</td>
//               <td className="py-2 px-4">{row.qty}</td>
//               <td className="py-2 px-4">
//                 <span
//                   className={
//                     row.status === "Dispatched"
//                       ? "text-green-600"
//                       : row.status === "In Transit"
//                       ? "text-yellow-600"
//                       : "text-blue-600"
//                   }
//                 >
//                   {row.status}
//                 </span>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

const ShipmentTable = ({ shipments }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Dispatched': return 'bg-blue-100 text-blue-800';
      case 'In Transit': return 'bg-yellow-100 text-yellow-800';
      case 'Processing': return 'bg-orange-100 text-orange-800';
      case 'Delivered': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Dispatched': return <Truck className="h-4 w-4" />;
      case 'In Transit': return <Clock className="h-4 w-4" />;
      case 'Processing': return <AlertCircle className="h-4 w-4" />;
      case 'Delivered': return <CheckCircle className="h-4 w-4" />;
      default: return null;
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 font-semibold text-gray-700 text-sm">Shipment ID</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-700 text-sm">Client</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-700 text-sm">Quantity</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-700 text-sm">Status</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-700 text-sm">Actions</th>
          </tr>
        </thead>
        <tbody>
          {shipments.map((shipment, index) => (
            <tr key={shipment.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
              <td className="py-4 px-4">
                <span className="font-medium text-gray-900">{shipment.id}</span>
              </td>
              <td className="py-4 px-4">
                <div>
                  <p className="font-medium text-gray-900">{shipment.client}</p>
                  <p className="text-sm text-gray-500">Premium Client</p>
                </div>
              </td>
              <td className="py-4 px-4">
                <span className="text-gray-900">{shipment.qty} kg</span>
              </td>
              <td className="py-4 px-4">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(shipment.status)}`}>
                  {getStatusIcon(shipment.status)}
                  <span className="ml-1">{shipment.status}</span>
                </span>
              </td>
              <td className="py-4 px-4">
                <button className="text-gray-400 hover:text-gray-600 transition-colors">
                  <MoreHorizontal className="h-4 w-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default ShipmentTable